export default {
  'api': {
    'register': '/base/register',
    'login': '/base/login',
    'modifyUser': '/user/modifyInfo',
    'modifyWalletChia': '/user/modifyChiaWallet',
    'userDetail': '/user/detail'
  },

  'userData': 'userData',
  'userToken': 'token',
  'ethAddress': 'ethereum_eth_address',
  'ethSign': 'ethereum_eth_sign',
  'authMsg': 'ethereum_auth_msg'
}